









































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import EventBus from "@/utils/eventBus";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class ToastContainer extends Vue {
  //   @Prop({ default: "default value" })
  //   private propB: string;
  private show: boolean = false;
  private timer: any = null; //toast显示的timer计时器
  private defaultTime: number = 2000; //默认显示toast的时间
  private toastWidth: number = 0; //toast弹窗宽度设置
  private toastType: string = ""; //显示的toast图标类型
  private toastContext: string = ""; //显示的toast的文案
  private way: string = ""; //获取金币的方式
  private coins: number = 0; //获得金币的数量

  private hideToast(duration: number) {
    this.timer = setTimeout(() => {
      this.show = false;
      this.toastType = "";
      this.toastContext = "";
      clearTimeout(this.timer);
    }, duration);
  }

  private clickMask() {
    // this.show = false;
    // this.toastType = "";
    // this.toastContext = "";
  }

  private mounted() {
    EventBus.$on("toast-show", (payload: any) => {
      clearTimeout(this.timer);
      this.show = true;
      this.toastType = "";
      this.toastContext = "";
      this.toastWidth = 0;
      if (payload.hasOwnProperty("type")) {
        this.toastType = payload.type;
      } else {
        this.toastType = "";
      }
      if (payload.hasOwnProperty("way")) {
        this.way = payload.way;
      }
      if (payload.hasOwnProperty("coins")) {
        this.coins = payload.coins;
      }
      if (payload.hasOwnProperty("toastWidth")) {
        this.toastWidth = payload.toastWidth;
      } else {
        this.toastWidth = 0;
      }
      if (payload.hasOwnProperty("content")) {
        this.toastContext = payload.content;
      } else {
        this.toastContext = "";
      }
      if (payload.hasOwnProperty("duration")) {
        if (payload.duration === "infinite") {
          return;
        } else {
          this.hideToast(payload.duration);
        }
      } else {
        this.hideToast(this.defaultTime);
      }
    });
    EventBus.$on("toast-hide", () => {
      this.show = false;
      this.toastType = "";
      this.toastContext = "";
      clearTimeout(this.timer);
    });
  }
}
